// ----------------------------------------------------------------------
// <copyright file="Izenda.ExpressionFieldName.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var updateArray = require('share/utils/Izenda.ArrayUtils').updateArray;
  var sortArray = require('share/utils/Izenda.ArrayUtils').sortArray;
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');
  var AppGlobal = require('Izenda.AppGlobal');
  var { getOr } = require('lodash/fp');
  function FieldName(detail) {
    this.id = detail.id;
    this.tempId = detail.tempId;
    this.name = detail.name;
    this.dataType = detail.dataType || detail.izendaDataType;
    this.description = detail.description || detail.expression;
    this.databaseName = detail.databaseName;
    this.schemaName = detail.schemaName;
    this.querySourceName = detail.querySourceName;
  }

  function DataSource(detail) {
    this.id = detail.id;
    this.name = detail.name;
    this.fieldNames = detail.fields;
    this.databaseName = detail.connectionName;
    this.schemaName = detail.querySourceCategoryName;
  }

  function ExpressionFieldName(data) {
    var colSortDir = {
      name: AppGlobal.advancedSettings.other.sortColumnNameValue ? null : 'ASC'
    };

    this.backupFieldNames = [];
    var props = {
      fieldNames: [], // array of FieldName
      selectedDataSource: {}, // data source object
      dataSources: [], // array of DataSource
      pageInfo: new PagingModel(colSortDir)
    };

    m.extendObservable(this, props);

    this.fetchData(data);
  }

  /**
   * Populate detail for object.
   * @param  {object} data
   */
  ExpressionFieldName.prototype.fetchData = function(data) {
    data = data || {};
    m.transaction(
      function() {
        this.fetchFieldNames(data.fieldNames);
        this.updateSelectedDataSource(data.selectedDataSource);
        this.fetchDataSources(data.dataSources);
      }.bind(this)
    );
  };

  /**
   * Populate detail for field name list.
   * @param  {object} fieldNames
   */
  ExpressionFieldName.prototype.fetchFieldNames = function(fieldNames) {
    var createFieldName = function(itemData) {
      return new FieldName(itemData);
    };

    updateArray(this.fieldNames, fieldNames, createFieldName);
    this.sort(this.fieldNames);
    updateArray(this.backupFieldNames, fieldNames, createFieldName);
  };

  /**
   * Populate detail for data source list.
   * @param  {object} dataSources
   */
  ExpressionFieldName.prototype.fetchDataSources = function(dataSources) {
    var createDataSource = function(itemData) {
      return new DataSource(itemData);
    };

    updateArray(this.dataSources, dataSources, createDataSource);
  };

  /**
   * Populate selected data source.
   * @param  {object} datasource
   */
  ExpressionFieldName.prototype.updateSelectedDataSource = function(datasource) {
    this.selectedDataSource = datasource;
  };

  /**
   * Load id of selected data source.
   */
  ExpressionFieldName.prototype.getSelectedDataSourceId = function() {
    return getOr(null, 'id', this.selectedDataSource);
  };

  /**
   * Sort file name list.
   */
  ExpressionFieldName.prototype.sort = function() {
    this.pageInfo.buildPagingRequest();
    var sortOrders = this.pageInfo.sortOrders;

    var sortedFieldNames = [];
    if (!sortOrders) {
      sortedFieldNames = this.backupFieldNames;
    } else {
      sortedFieldNames = sortArray(this.fieldNames, sortOrders);
    }

    updateArray(this.fieldNames, sortedFieldNames, function(itemData) {
      return new FieldName(itemData);
    });
  };

  module.exports = ExpressionFieldName;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ExpressionFieldName.js